import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid';
import React from 'react'

const PersonalTransactions = ({transaction}) => {
  return (
    <div className="text-sm grid grid-cols-6 px-5 space-x-2 py-2 my-2 mx-1 rounded-sm bg-[#434242] text-white">
      <p className="col-span-2 truncate text-xs">
        {transaction?.transactionHash}
      </p>
      <p className="col-span-2 truncate text-xs">{transaction?.address}</p>
      <p className="col-span-1 truncate text-xs">{transaction?.amount}</p>
      <div className="text-sm col-span-1">
        {transaction?.status ? (
          <div className="flex items-center text-xs space-x-3 justify-end">
            <CheckCircleIcon className="text-green-500 h-5" />
            <p>Success</p>
          </div>
        ) : (
          <div className="flex items-center text-xs space-x-3">
            <ExclamationCircleIcon className="text-red-500 h-5" />
            <p>Failed</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PersonalTransactions